import './styles/index.css';
import React, { useEffect, useState } from 'react';
import Contact from './components/Contact';
import Navbar from './components/Navbar';
import Project from './components/Project';
import About from './components/About';
import ProfessionalResume from './components/Professional_Resume';
import Education from './components/Education';
import Blog from './pages/blog';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LanguageProvider, useLanguage } from './contexts/LanguageContext';

const AppRouter = () => {
  const { t } = useLanguage();
  const [showBackToTop, setShowBackToTop] = useState(false);

  useEffect(() => {
    const sections = document.querySelectorAll('section');

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('active');
        } else {
          entry.target.classList.remove('active');
        }
      });
    }, { threshold: 0.1 });

    sections.forEach((section) => {
      observer.observe(section);
    });

    return () => {
      sections.forEach((section) => {
        observer.unobserve(section);
      });
    };
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      setShowBackToTop(window.scrollY > 500);
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <Routes>
      <Route
        path="/"
        element={
          <>
            <div className="background">
              <div id="stars"></div>
              <div id="stars2"></div>
              <div id="stars3"></div>
            </div>
            <header className="header">
              <Navbar />
            </header>
            <main>
              <section id="home">
                <div className="text-content">
                  <span className="eyebrow">{t.home.eyebrow}</span>
                  <h1>{t.home.title}</h1>
                  <p>{t.home.description}</p>
                  <div className="home-actions">
                    <a className="primary-action" href={`mailto:atila.o.rocha@gmail.com?subject=${encodeURIComponent(t.contact.emailSubject)}`}>
                      {t.home.primaryAction}
                    </a>
                    <a className="secondary-action" href="#resumo-profissional">
                      {t.home.secondaryAction}
                    </a>
                  </div>
                </div>
              </section>
              <section id="sobre">
                <About />
              </section>
              <section id="projetos">
                <Project />
              </section>
              <section id="educação">
                <Education />
              </section>
              <section id="resumo-profissional">
                <ProfessionalResume />
              </section>
              <section id="contato">
                <Contact />
              </section>
            </main>
            {showBackToTop && (
              <button className="back-to-top" type="button" onClick={scrollToTop} aria-label={t.home.backToTop}>
                ↑
                <span>{t.home.backToTop}</span>
              </button>
            )}
          </>
        }
      />
      <Route path="/blog" element={<Blog />} />
    </Routes>
  );
};

const App: React.FC = () => {
  return (
    <LanguageProvider>
      <BrowserRouter basename="/">
        <AppRouter />
      </BrowserRouter>
    </LanguageProvider>
  );
};

export default App;